export default "__VITE_ASSET__Dh7QmXPP__"